import React from "react";

import MuiInput from "@mui/material/Input";

interface IInputNumeric {
  value: string;
  submitHandler: any;
  inputProps?: any;
  prefix?: string;
  suffix?: string;
  unit?: string;
  disabled?: boolean;
}
const InputNumeric: React.FC<IInputNumeric> = ({
  inputProps = {
    sx: {
      typography: "body1",
      width: 70,
      textAlign: "center",
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  },
  submitHandler,
  value,
  prefix,
  suffix,
  unit,
  disabled = false,
}): JSX.Element => {
  const [localValue, setLocalValue] = React.useState(String(value));

  React.useEffect(() => {
    setLocalValue(String(value));
  }, [value]);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const onChangeHandler = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => /^[0-9]*$/.test(event.target.value) && setLocalValue(event.target.value);

  const submit = () => {
    submitHandler(localValue);
  };

  return (
    <MuiInput
      inputProps={inputProps}
      value={localValue}
      onChange={onChangeHandler}
      onBlur={submit}
      startAdornment={prefix}
      endAdornment={suffix || unit}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      disableUnderline={disabled}
    />
  );
};

export default InputNumeric;
